'use client'

import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons/faLocationDot'
import { getPreferredTrialTitleForAlgoliaTrial } from '@modules/trials/helpers/getPreferredTrialTitle'
import type { AlgoliaTrialHit } from '@modules/trials/search/const'
import React from 'react'

interface TrialPreviewSidebarProps {
  setIsOverlayOpen: React.Dispatch<React.SetStateAction<boolean>>
  setPreviewTrial: React.Dispatch<
    React.SetStateAction<AlgoliaTrialHit | undefined>
  >
  trialGroup: AlgoliaTrialHit[]
}

// Component definition wrapped in React.memo
const TrialPreviewSidebar: React.FC<TrialPreviewSidebarProps> = React.memo(
  ({ setIsOverlayOpen, setPreviewTrial, trialGroup }) => {
    return (
      <div className='hidden h-full cursor-pointer select-none divide-y divide-neutral200 overflow-y-auto rounded-lg border-2 border-neutral200 bg-white lg:block'>
        {trialGroup.map((item) => {
          const preferredTitle = getPreferredTrialTitleForAlgoliaTrial(
            {
              abbreviatedTitle: item.abbreviatedTitle ?? null,
              conjuredTitle: item.conjuredTitle ?? null,
              nctId: item.nctId ?? '',
              treatments: item.treatments ?? [],
            },
            item.primaryCondition ?? '',
          )
          const preferredDescription = item.nlpBriefSummary ?? item.briefSummary
          return (
            <div
              className='space-y-4 p-3'
              key={item.objectID}
              onClick={() => {
                setPreviewTrial(item)
                setIsOverlayOpen(true)
              }}
            >
              <div className='space-y-1'>
                <span className='pb-4 text-sm font-bold text-black antialiased'>
                  {preferredTitle}
                </span>
                <span className='flex items-center gap-1'>
                  <Icon icon={faLocationDot} />
                  <span className='text-xs text-neutral700 antialiased'>
                    {item.locationCities?.[0] ?? ''}
                    {item.locationCities?.[0] && item.locationStates?.[0]
                      ? ', '
                      : ''}
                    {item.locationStates?.[0] ?? ''}
                  </span>
                </span>
              </div>
              <span
                className='line-clamp-2 text-xs text-neutral700 antialiased'
                title={preferredDescription}
              >
                {preferredDescription}
              </span>
              {item.enrollmentCount && (
                <Text className=' text-neutral600' styleName='p-xxtiny-strong'>
                  {item.enrollmentCount} Participants Needed
                </Text>
              )}
            </div>
          )
        })}
      </div>
    )
  },
)

TrialPreviewSidebar.displayName = 'TrialPreviewSidebar'
export default TrialPreviewSidebar
